import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

@Component({
  selector: 'ld-autopay-promo-banner',
  template: `
    @if (variant() === 'full') {
    <!-- Full Banner -->
    <div
      class="bg-gradient-to-r from-ld-primary to-ld-primary rounded-2xl p-6 text-white relative overflow-hidden"
    >
      @if (dismissible()) {
      <button
        type="button"
        class="absolute top-3 right-3 w-8 h-8 flex items-center justify-center rounded-full bg-white/20 hover:bg-white/30 transition-colors"
        aria-label="Dismiss banner"
        (click)="dismiss.emit()"
      >
        <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }
      <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div class="flex-1">
          <h3 class="text-xl font-semibold mb-2">Never Miss a Payment</h3>
          <p class="text-white/90 text-sm">
            Set up autopay and enjoy peace of mind knowing your mortgage payment is always on time.
          </p>
        </div>
        <button
          type="button"
          class="shrink-0 bg-white text-ld-primary font-bold text-sm uppercase tracking-wider px-6 py-3 rounded-full hover:bg-white/90 transition-colors"
          (click)="setupClick.emit()"
        >
          Set Up Autopay
        </button>
      </div>
    </div>
    } @else {
    <!-- Compact Banner -->
    <div
      class="bg-ld-primary/10 border border-ld-primary/20 rounded-xl p-4 flex items-center justify-between gap-4"
    >
      <div class="flex items-center gap-3">
        <div class="w-10 h-10 rounded-full bg-ld-primary/20 flex items-center justify-center shrink-0">
          <svg class="w-5 h-5 text-ld-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div>
          <p class="font-medium text-ld-neutral-700 text-sm">Save time with Autopay</p>
          <p class="text-xs text-ld-neutral-500">Automatic payments, zero hassle</p>
        </div>
      </div>
      <button
        type="button"
        class="shrink-0 text-ld-primary font-semibold text-sm hover:underline"
        (click)="setupClick.emit()"
      >
        Set Up
      </button>
      @if (dismissible()) {
      <button
        type="button"
        class="shrink-0 w-6 h-6 flex items-center justify-center text-ld-neutral-400 hover:text-ld-neutral-600"
        aria-label="Dismiss"
        (click)="dismiss.emit()"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
      }
    </div>
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AutopayPromoBannerComponent {
  variant = input<'full' | 'compact'>('compact');

  dismissible = input<boolean>(true);

  setupClick = output<void>();

  dismiss = output<void>();
}
